import React, { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { bemCssModules, getTestId } from '@utils';

import Dropdown from '@components/Dropdown';
import Input from '@components/Input';

import { statesSelector } from './selectors';
import { SelectedState, Props } from './types';

import style from './State.scss';

const cn = bemCssModules(style, 'State');
const ti = getTestId('State');

export const State: CustomFC<Props> = ({ className, onChangeValue, initialValue, ...props }) => {
  const states = useSelector(statesSelector);
  const { t } = useTranslation();

  const statesRef = useRef<HTMLInputElement>(null);
  const [search, setSearch] = useState('');
  const [selectedState, setSelectedState] = useState<SelectedState | undefined>(initialValue);

  const onChange = (value: SelectedState) => {
    setSelectedState(value);
    setSearch('');
    if (value.value !== selectedState?.value) onChangeValue(value.value);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedState(undefined);
    onChangeValue('');
    setSearch(event.target.value);

    states.forEach(state => {
      if (state.label?.toUpperCase() === event.target.value.toUpperCase()) {
        onChange(state);
      }
    });
  };

  const filter = (option: SelectedState) => {
    const { label = '' } = option;
    return label.toLowerCase().includes((search || '').toLowerCase());
  };

  const list = states.filter(filter);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <Input
        {...props}
        ref={statesRef}
        value={search || selectedState?.label || ''}
        name="states"
        onChange={handleSearch}
      />

      <Dropdown
        header={<div className={cn('header')}>{t('common.select_your_state_title')}</div>}
        className={cn('modal')}
        data={list}
        placeholderSearch={t('common.state_title')}
        value={selectedState?.value}
        onChange={onChange}
        controller={statesRef}
        search={search}
        isSearch
        onSearch={handleSearch}
      />
    </div>
  );
};

export default State;
